import { getAnalytics, logEvent, Analytics, isSupported } from 'firebase/analytics';
import { getFirebaseApp } from './firebaseAppCheck';

let analytics: Analytics | null = null;

const BACKEND_URL = process.env.REACT_APP_API_URL || 'https://investmenter-backend-1081814658115.europe-west1.run.app';

// Send event to our own Firestore analytics (for admin dashboard)
function sendToBackend(type: string, email?: string, page?: string, metadata?: any) {
  try {
    const storedEmail = email || localStorage.getItem('investorEmail') || 'anonymous';
    fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, email: storedEmail, page, metadata })
    }).catch(() => {}); // fire and forget
  } catch {}
}

export async function initAnalytics(): Promise<Analytics | null> {
  if (analytics) return analytics;

  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn('Firebase Analytics not supported in this environment');
      return null;
    }

    const app = getFirebaseApp();
    analytics = getAnalytics(app);
    console.log('Firebase Analytics initialized');
    return analytics;
  } catch (error) {
    console.error('Failed to initialize Firebase Analytics:', error);
    return null;
  }
}

export function trackPageView(pageName: string) {
  if (analytics) logEvent(analytics, 'page_view', { page_title: pageName });
  sendToBackend('page_view', undefined, pageName);
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (analytics) logEvent(analytics, eventName, params);
}

export function trackLogin(method: string) {
  if (analytics) logEvent(analytics, 'login', { method });
  sendToBackend('login');
}

export function trackDocumentView(docType: string) {
  if (analytics) logEvent(analytics, 'view_document', { document_type: docType });
  sendToBackend('doc_view', undefined, docType);
}
